import { GameRangeFilterOption, PeriodRange } from '@statsbomb/parachute-types';

export const GAME_RANGE_OPTIONS = {
  period: { key: 'period', translation: { key: 'period', ns: 'filters' } },
  dateRange: { key: 'dateRange', translation: { key: 'dateRange', ns: 'filters' } },
} as const;

export const GAME_RANGE_FILTER_OPTIONS: GameRangeFilterOption[] = Object.values(GAME_RANGE_OPTIONS);

export const PERIOD_RANGES = {
  // A valid number that is greater than the maximum number of games that we're ever likely to have.
  allGames: { translation: { key: 'allGames', ns: 'filters' }, value: Number.MAX_SAFE_INTEGER },
  lastMatch: { translation: { key: 'lastMatch', ns: 'filters' }, value: 1 },
  lastXGames5: { translation: { key: 'lastXGames', count: 5, ns: 'filters' }, value: 5 },
  lastXGames10: { translation: { key: 'lastXGames', count: 10, ns: 'filters' }, value: 10 },
  lastXGames20: { translation: { key: 'lastXGames', count: 20, ns: 'filters' }, value: 20 },
  lastXMonths3: { translation: { key: 'lastXMonths', count: 3, ns: 'filters' }, value: 3 },
  lastXMonths6: { translation: { key: 'lastXMonths', count: 6, ns: 'filters' }, value: 6 },
  lastXMonths12: { translation: { key: 'lastXMonths', count: 12, ns: 'filters' }, value: 12 },
} as const;

export const PERIOD_RANGE_OPTIONS: PeriodRange[] = Object.values(PERIOD_RANGES);

export const PERIOD_TRANSLATION_KEYS: readonly string[] = ['allGames', 'lastMatch', 'lastXGames', 'lastXMonths'];
